import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {Token} from '@moveup/common';

@Injectable({
  providedIn: 'root'
})
export class CodeService {

  constructor(private api: ApiService) { }

  async getCodeDetails(code: string){
    return this.api.get<Token>(`/code/${code}`);
  }

  isValid(code: string) {
    return this.api.get<boolean>(`/code/${code}/valid`);
  }
}
